import { useState, useCallback } from "react";
import { deleteLessonProduct, deletePracticeProduct } from "api/class";
import { useSnackbar } from "contexts/SnackbarContext";

const useDeleteSchedule = () => {
    const { showSuccess, showError } = useSnackbar();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = useCallback(
        async (
            scheduleId,
            scheduleType,
            { onSuccess, confirm = true } = {}
        ) => {
            if (isDeleting) return;
            if (confirm && !window.confirm(`스케쥴을 삭제하시겠습니까?\n강습은 연습반도 함께 삭제됩니다.`)) return;
            setIsDeleting(true);
            try {
                if (scheduleType === "lesson") {
                    const res = await deleteLessonProduct(scheduleId);
                    if (res?.status >= 200 && res?.status < 300) {
                        showSuccess("강습이 삭제되었습니다.");
                        onSuccess?.();
                    }
                } else if (scheduleType === "practice") {
                    const res = await deletePracticeProduct(scheduleId);
                    if (res?.status >= 200 && res?.status < 300) {
                        showSuccess("연습반이 삭제되었습니다.");
                        onSuccess?.();
                    }
                }
            } catch (error) {
                showError(
                    "스케쥴 삭제에 실패했습니다. 담당자에게 문의하여 삭제해주세요"
                );
            } finally {
                setIsDeleting(false);
            }
        },
        [isDeleting, showSuccess, showError]
    );

    return { handleDelete, isDeleting };
};

export default useDeleteSchedule;
